// src/app/my-products/shared/category.guard.ts
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class CategoryGuard implements CanActivate {
  private validCategories = ['Cheveux', 'Coffrets', 'Idées Cadeaux', 'Maquillage', 'Parfums', 'Promotions', 'Soins'];


  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const category = route.params['category'];
    if (this.validCategories.includes(category)) {
      return true;
    }
    this.router.navigate(['/home']);
    return false;
  }
}
